module.exports = __webpack_public_path__ + "static/media/21.5e268de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/21.jpg
// module id = 480
// module chunks = 0